import React, { useEffect, useState } from 'react';
import SecurityDepositSequencing from './SecurityDepositSequencing';
import { getDropdowns } from './constant';
import { ReactComponent as BackIcon } from 'assets/img/svg/BackButton.svg';
import { useHistory } from "react-router";


const SecurityDepositSequencingPage = () => {
  const [dropdownData, setDropdownData] = useState({
    loading: false,
    data: {}
  });

  const [defaultRow, setDefaultRow] = useState({});
  const history = useHistory();

  const getDropdown = async () => {
    setDropdownData(prev => ({ ...prev, loading: true }));
    const data = await getDropdowns();
    setDropdownData({ loading: false, data });
  }

  useEffect(() => {
    getDropdown()
  }, [])

  return (
    <div className={`remove-container-top-space d-flex flex-column p-3`}>

      <div className='mb-3'>
        <BackIcon onClick={() => history.goBack()} />
        <span className="ml-3 heading-4 color-dark">
          Career wise collection config
        </span>
      </div>

      <SecurityDepositSequencing
        dropdownData={dropdownData?.data}
        dropdownDataLoading={dropdownData?.loading}
        setDefaultRow={setDefaultRow}
      />

      <SecurityDepositSequencing
        dropdownData={dropdownData?.data}
        dropdownDataLoading={dropdownData?.loading}
        isBranchLevelConfig
        defaultRow={defaultRow}
      />
    </div>

  );
}

export default SecurityDepositSequencingPage;